import React, { useEffect, useState } from "react";
import AdminLeave from "./component/AdminLeave";
import { LeaveDetails } from "../Services/ApiCalling";
import { useNavigate } from "react-router-dom";
import ElbowCurve from "./component/ElbowCurve";
import apexCharts from "./component/Chart";
import ClusterTable from "./component/ClusterTable";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const AdminLeaveView = () => {
  const [leaveUsers, setLeaveUsers] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);
  const [totalRecord, settotalRecord] = useState(null);
  const [totalPage, settotalPage] = useState(null);
  const [showClusterTable, setShowClusterTable] = useState(false);

  const [isCreateClusterDisabled, setIsCreateClusterDisabled] = useState(false); // New state to track button disabled state
  const navigate = useNavigate();

  const token = localStorage.getItem("LogIn_Token");

  const date = new Date();
  let curr_date = date.toISOString();
  let first_date = new Date(date.getFullYear(), date.getMonth() - 1, 1);

  const [status, setStatus] = useState();
  const [appType, setAppType] = useState({
    value: "WFH",
    label: "Work From Home",
  });
  const [appStatus, setAppStatus] = useState({
    value: "PENDING",
    label: "Pending",
  });
  const [from, setFrom] = useState(first_date?.toISOString());
  const [to, setTo] = useState(curr_date);
  const [empName, setEmpName] = useState("");

  const TYPE = appType?.value;
  const STATUS = appStatus?.value;

  const getLeaveData = async (token, empName, TYPE, STATUS, FROM, TO) => {
    const res = await LeaveDetails(token, empName, TYPE, STATUS, FROM, TO);
    console.log("res", res);
    setCurrentPage(res?.pagination?.currentPage);
    setPageSize(res?.pagination?.pageSize);
    settotalRecord(res?.pagination?.totalRecords);
    settotalPage(res?.pagination?.totalPages);
    setIsLoading(false);
    setLeaveUsers(res.data);
  };

  console.log(
    "currentPagecurrentPage_datasegmention",
    currentPage,
    pageSize,
    totalRecord,
    totalPage
  );

  const handleRightButtonClick = () => {
    navigate("/insight");
  };

  const handleLeftButtonClick = () => {
    navigate("/data-processing");
  };

  const handleViewData = () => {
    setShowClusterTable(!showClusterTable);
  };

  useEffect(() => {
    const leaveData = setTimeout(() => {
      getLeaveData(token, empName, TYPE, STATUS, from, to);
    }, 600);
    return () => clearTimeout(leaveData);
  }, [empName, TYPE, STATUS, from, to]);

  return (
    <>
      <AdminLeave
        setEmpName={setEmpName}
        from={from}
        to={to}
        STATUS={STATUS}
        empName={empName}
        TYPE={TYPE}
        setAppType={setAppType}
        setAppStatus={setAppStatus}
        setFrom={setFrom}
        setTo={setTo}
        isLoading={isLoading}
        currentPage={currentPage}
        pageSize={pageSize}
        totalRecord={totalRecord}
        totalPage={totalPage}
        setCurrentPage={setCurrentPage}
        setPageSize={setPageSize}
        leaveUsers={leaveUsers}
        getLeaveData={getLeaveData}
        emp_sts={status}
        setIsCreateClusterDisabled={setIsCreateClusterDisabled} // Passing prop to track button state
      />
      {!isCreateClusterDisabled && (
        <>
          <ElbowCurve />
          <div className="page-wrapper">
            <div className="d-grid gap-2 d-md-flex justify-content-md-start">
              <button
                className="btn btn-primary ms-4"
                type="button"
                onClick={handleViewData}
              >
                View Data
              </button>
            </div>
          </div>

          {showClusterTable && (
            <ClusterTable
              isLoading={isLoading}
              currentPage={currentPage}
              pageSize={pageSize}
              // totalRecord={null}
              // totalPage={null}
              setCurrentPage={setCurrentPage}
            />
          )}
        </>
      )}

      <div className="page-wrapper">
        <div className="footer">
          {" "}
          <button className="prev-button" onClick={handleLeftButtonClick}>
            <FaArrowLeft style={{ marginRight: "8px" }} />
            Previous Step
          </button>
          <button className="next-button" onClick={handleRightButtonClick}>
            Next Step <FaArrowRight style={{ marginRight: "8px" }} />
          </button>
        </div>
      </div>
    </>
  );
};

export default AdminLeaveView;
